<template>
  <v-dialog
    :value="value"
    persistent
    fullscreen
    @change="$emit('input', value)"
  >
    <v-card id="scan-choice">
      <v-toolbar
        color="primary"
        class="toolbar"
      >
        <v-toolbar-title class="ml-0">
          {{ $t('title.scan_choice') }}
        </v-toolbar-title>
      </v-toolbar>

      <div
        v-show="message"
        class="pa-3 my-1 text-center"
        :class="indexError !== null ? 'error body-1' : 'info body-2'"
      >
        {{ message }}
      </div>

      <div class="body-2 px-2 my-3 text-center">
        {{ $t('info.scan_choice') }}
      </div>

      <v-divider />

      <div class="bloc text-center mt-3">
        <v-btn
          v-for="(type, index) in TypeScanEnum"
          v-show="type.view === 'scan-keyboard' ? usemanscan : type.show"
          :key="index"
          :name="type.text"
          :disabled="indexError === index"
          class="bloc-medium mb-3"
          outlined
          @click="save(index)"
        >
          <v-icon class="mr-3">
            {{ type.icon }}
          </v-icon>
          <span class="align-middle">
            {{ $t(type.text) }}
          </span>
        </v-btn>
      </div>

      <div class="info-card bottom-card">
        <v-icon left>
          {{ IconEnum.info }}
        </v-icon>
        <span>
          {{ $t('info.change_scan_choice') }}
          <router-link
            to="settings"
            class="white--text"
          >{{ $t('info.change_scan_choice_link') }}</router-link>
        </span>
      </div>

      <bottom-action @del="close" />
    </v-card>
  </v-dialog>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'
import { TypeScanEnum, IconEnum } from '@/modules/Enums'

export default {
  name: 'ScanChoiceDialog',

  props: {
    value: { type: Boolean, default: false },
    message: { type: String, default: null },
    indexError: { type: Number, default: null }
  },

  data () {
    return {
      TypeScanEnum,
      IconEnum
    }
  },

  computed: {
    usenfc () { return this.$store.state.usenfc },
    useqrcodes () { return this.$store.state.useqrcodes },
    usemanscan () { return this.$store.state.usemanscan },
    favorite: {
      get () { return this.$store.state.favoriteScan },
      set (val) {
        // Changement du scan par défaut en cas de désactivation
        if (val === 0 && !this.usenfc) {
          this.$store.commit('usenfc', true)
          localStorage.setItem('usenfc', true)
        } else if (val === 1 && !this.useqrcodes) {
          this.$store.commit('useqrcodes', true)
          localStorage.setItem('useqrcodes', true)
        }
        MetierLocalStorage.setFavoriteScan(val)
        this.$store.commit('favoriteScan', val)
      }
    }
  },

  methods: {
    save (index) {
      // Sauvegarde du favori
      this.favorite = index
      // Lancement de l'action associée
      this.$emit('input', false)
      this.$nextTick(() => {
        this.$emit('action', this.TypeScanEnum[index].view)
      })
    },
    close () {
      this.$emit('input', false)
      if (this.indexError !== null) {
        this.$nextTick(() => {
          this.$emit('hide')
        })
      }
    }
  }
}
</script>
